import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';

import * as selectors from './selector';
import { getNewsList, refreshNewsList, setSentNewsDetail } from './thunk';

import type { TableBaseColumnType, TableBaseRowType } from '@/components/TableBase/Body';
import type { EntityDataPubNotNullType } from '@/domain/entityPub';
import type { ContentJson } from '@/domain/news/service/entity/contentEntity';
import type { SentNewsJsonPub, SentNewsJsonPvt } from '@/domain/news/service/entity/sentNewsEntity';

import AdditionalLoading from '@/components/AdditionalLoading';
import Detail from '@/components/Detail';
import TableBase from '@/components/TableBase';
import Title from '@/components/Title';
import NewsContent from '@/domain/news/component/NewsContent';
import { toStringShort } from '@/utils/date';

const News: React.FC = () => {
  const dispatch = useDispatch();
  const isEnableLoading = useSelector(selectors.isEnableLoadingSelector);
  const isInit = useSelector(selectors.isInitSelector);
  const newsList = useSelector(selectors.sentNewsListSelector);
  const sentNews = useSelector(selectors.sentNewsSelector);
  React.useEffect(() => {
    if (!isInit) {
      dispatch(refreshNewsList());
    }
  }, [dispatch, isInit]);
  const rows = [];
  for (let i = 0; i < newsList.length; i += 1) {
    rows.push({
      id: newsList[i].data.sendDatetime,
      title: newsList[i].data.title,
      dateTime: toStringShort(new Date(newsList[i].data.sendDatetime)),
      fontWeight: !newsList[i].pub?.data.alreadyRead ? 'bold' : '',
      backgroundColor: newsList[i].pub?.data.alreadyRead ? '#ededed' : '',
    });
  }
  const columns: TableBaseColumnType[] = [
    { id: 'dateTime', label: '日時', minWidth: 60 },
    { id: 'title', label: 'タイトル', minWidth: 100 },
  ];
  const actions = [
    {
      icon: <InfoIcon />,
      title: '詳細表示',
      action: async (r: TableBaseRowType) => {
        const item = newsList.find((v) => v.data.sendDatetime === r.id);
        if (item) {
          dispatch(setSentNewsDetail({ item }));
        }
      },
    },
  ];
  return (
    <div>
      <Title title="お知らせ" />
      <div>
        <TableBase
          rows={rows}
          columns={columns}
          actions={actions}
          refreshAction={() => dispatch(refreshNewsList())}
          isPagination={false}
          isShowFilter={false}
          isShowFooter={false}
        />
        <AdditionalLoading
          isEnableLoading={isEnableLoading}
          onClick={() => dispatch(getNewsList())}
        />
        {sentNews && (
          <Detail<{
            content: ContentJson,
            info: EntityDataPubNotNullType<SentNewsJsonPvt, SentNewsJsonPub>
          }>
            comp={NewsContent}
            close={() => {
              dispatch(setSentNewsDetail({ item: undefined }));
            }}
            data={sentNews}
            title="お知らせ"
          />
        )}
      </div>
    </div>
  );
};

export default News;
